import { Component } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-preview-confirmation-dialog',
    templateUrl: './preview-confirmation-dialog.component.html',
    styleUrls: ['./preview-confirmation-dialog.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule
    ]
})
export class PreviewConfirmationDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<PreviewConfirmationDialogComponent>
    ) { }

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
